import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCaIWlOmJ3B7sbZpMlIeNgUKZ8VSlfLTJA",
  authDomain: "section-looper.firebaseapp.com",
  projectId: "section-looper",
  storageBucket: "section-looper.firebasestorage.app",
  messagingSenderId: "399173172529",
  appId: "1:399173172529:web:794c43ddee4e4f7031c410"
};

const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const provider = new GoogleAuthProvider();
export const login = () => signInWithPopup(auth, provider);
export const logout = () => signOut(auth);
export const YT_API_KEY = "AIzaSyCwKLoe6r1yv2wyVSn4BvRKr7KppA6HglQ";
